export default __webpack_public_path__ + "1bffca36b067e00ee22c9da80ab3cfff.svg";